import { graphql } from "@/gql";

export const createBlogPostMutation = graphql(`
  mutation CreateBlogPost($input: CreateBlogPostInput!) {
    createBlogPost(input: $input) {
      id
      slug
    }
  }
`);

export const updateBlogPostMutation = graphql(`
  mutation UpdateBlogPost($id: ID!, $input: UpdateBlogPostInput!) {
    updateBlogPost(id: $id, input: $input) {
      id
      slug
    }
  }
`);

export const deleteBlogPostMutation = graphql(`
  mutation DeleteBlogPost($id: ID!) {
    deleteBlogPost(id: $id) {
      id
    }
  }
`);

export const syncBlogPostTagsMutation = graphql(`
  mutation SyncBlogPostTags($id: ID!, $tagIds: [ID!]!) {
    syncBlogPostTags(id: $id, tagIds: $tagIds) {
      id
      tags {
        id
      }
    }
  }
`);

export const translateBlogPostMutation = graphql(`
  mutation TranslateBlogPost($id: ID!, $locale: String) {
    translateBlogPost(id: $id, locale: $locale) {
      id
      translations {
        locale
        title
        excerpt
      }
      available_locales
    }
  }
`);

export const blogPostSlugAvailableQuery = graphql(`
  query BlogPostSlugAvailable($slug: String!, $locale: String, $excludeId: ID) {
    blogPostSlugAvailable(slug: $slug, locale: $locale, excludeId: $excludeId)
  }
`);
